import { RootState } from '../rootReducer';
import { Groupement } from '../types/user';
import { email_formater } from '../utils/text';

export const selectIsAuthenticated = (state: RootState): boolean => state.user !== null;

export const selectIsSsoUser = (state: RootState): boolean => state.user?.isSso ?? false;

export const selectIsAdmin = (state: RootState): boolean => state.user?.isAdmin ?? false;

export const selectUserId = (state: RootState): number | undefined => state.user?.id;

export const selectUserEmail = (state: RootState): string | undefined => state.user?.email;

export const selectFormattedUserEmail = (state: RootState): string =>
    state.user ? email_formater(state.user.email) : '';

export const selectUserMyId = (state: RootState): string | undefined => {
    const myId = state.user?.myId;
    return myId ? myId : undefined;
};

export const selectUserAgency = (state: RootState): string | undefined => state.user?.agency;

export const selectUserGroupement = (state: RootState): Groupement | undefined =>
    state.user?.groupement;

export const selectAutoPublish = (state: RootState): boolean => state.user?.autoPublish ?? false;

export const selectDisplayLogoOnPublications = (state: RootState): boolean =>
    state.user?.displayLogoOnPublications ?? false;

export const selectLogoUrl = (state: RootState): string | undefined => state.user?.logoUrl;
